export default __webpack_public_path__ + "static/SustainableFutures-VFT-VolunteerGuide-v2-58b2b733b271ad81e754958201b1e71f.pdf";